import AdminDashboard from "../components/admin/Dashboard";
import AdminDashboardLayout from "../components/AdminDashboardLayout"
function AdminDashboardPage(){
    return(<AdminDashboardLayout>
        <AdminDashboard/>
    </AdminDashboardLayout>)
}
export default AdminDashboardPage